import { render } from "./BlogContainer.vue?vue&type=template&id=28f28d83&scoped=true"
import script from "./BlogContainer.vue?vue&type=script&lang=js"
export * from "./BlogContainer.vue?vue&type=script&lang=js"

import "./BlogContainer.vue?vue&type=style&index=0&id=28f28d83&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f28d83"]])

export default __exports__